const IconFolder = ({
  color 
} : {color : any}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M4 26V8C4 7.73478 4.10536 7.48043 4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H11.6667C11.883 7 12.0936 7.07018 12.2667 7.2L15.7333 9.8C15.9064 9.92982 16.117 10 16.3333 10H25C25.2652 10 25.5196 10.1054 25.7071 10.2929C25.8946 10.4804 26 10.7348 26 11V14"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 26L7.77208 14.6838C7.83845 14.4847 7.96578 14.3115 8.13605 14.1888C8.30631 14.066 8.51088 14 8.72076 14H28.6126C28.771 14 28.9272 14.0377 29.0683 14.1099C29.2093 14.1821 29.3312 14.2867 29.4238 14.4153C29.5165 14.5438 29.5772 14.6926 29.6011 14.8492C29.625 15.0058 29.6114 15.1659 29.5613 15.3162L26 26H4Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

{/* <svg
  xmlns="http://www.w3.org/2000/svg"
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
>
  <path
    d="M4 26V8C4 7.73478 4.10536 7.48043 4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H11.6667C11.883 7 12.0936 7.07018 12.2667 7.2L15.7333 9.8C15.9064 9.92982 16.117 10 16.3333 10H25C25.2652 10 25.5196 10.1054 25.7071 10.2929C25.8946 10.4804 26 10.7348 26 11V14"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M4 26L7.77208 14.6838C7.83845 14.4847 7.96578 14.3115 8.13605 14.1888C8.30631 14.066 8.51088 14 8.72076 14H28.6126C28.771 14 28.9272 14.0377 29.0683 14.1099C29.2093 14.1821 29.3312 14.2867 29.4238 14.4153C29.5165 14.5438 29.5772 14.6926 29.6011 14.8492C29.625 15.0058 29.6114 15.1659 29.5613 15.3162L26 26H4Z"
    stroke="white"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>; */}

export default IconFolder;
